// ticket.status
const ticketStatus = {
    Cancelled: 'Cancelled',
    Lost: 'Lost',
    PaidOut: 'PaidOut',
    Registered: 'Registered',
    Won: 'Won'
};
export const { Cancelled, Lost, PaidOut, Registered, Won } = ticketStatus;
export default ticketStatus;
